import { useCallback, useEffect } from 'react';
import { loadCollectionAsync } from '../../data-layer/collections/actions';
import { selectCollectionById } from '../../data-layer/collections/selectors';
import { CollectionModel } from '../../data-layer/collections/types';
import { useDispatch } from '../../data-layer/useDispatch';
import { useSelector } from '../../data-layer/useSelector';

interface UseCollectionControllerParams {
    collectionId: string;
}

export const useCollection = (
    params: UseCollectionControllerParams,
): CollectionModel | undefined => {
    const { collectionId } = params;
    const dispatch = useDispatch();
    const onLoadCollection = useCallback(
        () => dispatch(loadCollectionAsync(collectionId)),
        [collectionId, dispatch],
    );

    const collectionModel = useSelector((state) => selectCollectionById(state, collectionId));

    useEffect(() => {
        onLoadCollection();
    }, []);

    return collectionModel;
};
